// @flow

import grammar from '../grammar.ohm-bundle';

export type InputFlag = {
  name: string,
  value: string,
  space: boolean,
};

export class InputCommand {
  env: {[string]: string};

  executable: string;

  structuredArgs: Array<string>;

  structuredFlags: Array<InputFlag>;

  isHelp: boolean;

  parseFailed: boolean;

  isHelp: boolean;

  raw: string;

  constructor(input: string) {
    this.env = {};
    // todo(tomer) - shoudl this be null? empty string makes the
    // type checking easier
    this.executable = '';
    this.structuredArgs = [];
    this.structuredFlags = [];
    this.isHelp = false;
    this.parseFailed = false;
    this.raw = input;

    this.parse(input);
  }

  parse(input: string) {
    const match = grammar.match(input);
    if (match.failed()) {
      this.parseFailed = true;
      return;
    }

    const semantics = grammar.createSemantics();

    semantics.addOperation('value', {
      Line(env, c) {
        return {
          type: 'line',
          data: {
            // todo - implement env parsing. This will require implementing
            // EnvironmentVariables semantic actions
            // env: env.value(),
            command: c.value(),
          },
        };
      },

      Command(ex, foa) {
        return {
          type: 'command',
          data: {
            exec: ex.value().join(''),
            foa: foa.value(),
          },
        };
      },

      Arguments(data) {
        return {type: 'argument', data: data.value()};
      },

      Flags(flag) {
        return flag.value();
      },

      ddash(_, flag, __, ___, data, space) {
        return {
          type: 'flag',
          data: {
            name: flag.value().join(''),
            value: data.value().join(''),
            space: space ? space.value().includes(' ') : false,
          },
        };
      },

      sdash(_, flag, __, ___, data, space) {
        return {
          type: 'flag',
          data: {
            name: flag.value(),
            value: data.value().join(''),
            space: space ? space.value().includes(' ') : false,
          },
        };
      },

      data(raw) {
        return raw.value();
      },

      dquote(_, raw, __) {
        return raw.value().join('');
      },

      squote(_, raw, __) {
        return raw.value().join('');
      },

      text(raw) {
        return raw.value().join('');
      },

      _iter(...children) {
        return children.map((c) => c.value());
      },

      _terminal() {
        return this.sourceString;
      },
    });

    const value = semantics(match).value();

    this.executable = value.data.command.data.exec;
    if (
      value.data.command.data.foa &&
      value.data.command.data.foa.length !== 0
    ) {
      const foa = value.data.command.data.foa;
      this.structuredArgs = this.extract(foa, 'argument');
      this.structuredFlags = this.extract(foa, 'flag');

      // Iterate through args and flags to see if this is a help command
      this.isHelp =
        this.structuredArgs.includes('help') ||
        this.structuredFlags.some(
          (flag) => flag.name === 'help' || flag.name === 'h',
        );
    }
  }

  extract(data: Array<any>, type: string): Array<any> {
    const matches = [];
    for (const datum of data) {
      if (datum && datum.type === type) {
        matches.push(datum.data);
      }
    }

    return matches;
  }

  // Render the executable + "sub-commands" (which may just be arguments)
  renderInvocation(): string {
    return this.raw;
  }
}
